import { render, staticRenderFns } from "./listening-choice.vue?vue&type=template&id=5b50f6b6&"
import script from "./listening-choice.vue?vue&type=script&lang=js&"
export * from "./listening-choice.vue?vue&type=script&lang=js&"
import style0 from "./listening-choice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports